"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyCoverMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const policy_entity_1 = require("./policy.entity");
let PolicyCoverMap = class PolicyCoverMap {
};
exports.PolicyCoverMap = PolicyCoverMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyCoverMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyCoverMap.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_template_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyCoverMap.prototype, "coverTemplateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], PolicyCoverMap.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_response", type: "json", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], PolicyCoverMap.prototype, "coverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], PolicyCoverMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], PolicyCoverMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => policy_entity_1.Policy, (policy) => policy.coverMappings, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], PolicyCoverMap.prototype, "policy", void 0);
exports.PolicyCoverMap = PolicyCoverMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_cover_map")
], PolicyCoverMap);
